export default () => {
  const sliderParents = document.querySelectorAll('.js-project-slider-parent');
  if (document.body.clientWidth > 1000) return;
  if (sliderParents.length < 1) return;

  [...sliderParents].forEach(sliderParent => {
    // Variables
    const slider = sliderParent.querySelector('.js-project-slider');
    const slide = sliderParent.querySelector('.js-project-slide');
    const filler = sliderParent.querySelector('.js-project-filler');
    const slides = sliderParent.querySelectorAll('.js-project-slide');
    if (slides.length < 1) return;
    let slided = 1;
    filler.style['min-width'] = `${slide.offsetWidth * 2}px`;
    filler.style['max-width'] = `${slide.offsetWidth * 2}px`;

    if (!('IntersectionObserver' in window)) {
      return;
    }

    // Make sure we update the slided count if the user scrolls through the slider
    const sliderObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const target = entry.target.dataset.target;
            slided = target;
          }
        });
      },
      { threshold: 0.8, root: slider }, // Add 50%, add active
    );

    [...slides].forEach(slide => {
      sliderObserver.observe(slide);
    });
  }); // end foreach
};



// WEBPACK FOOTER //
// ./src/js/modules/ProjectSliderMobile.js